export default () => (
  /**
   * Ícone utilizado para configuração de
   * tamanho da fonte dos rótulos.
   */
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.17285 0.386719V3.38672H11.1729V15.3867H14.1729V3.38672H19.1729V0.386719H6.17285ZM0.172852 8.38672H3.17285V15.3867H6.17285V8.38672H9.17285V5.38672H0.172852V8.38672Z"
      fill="#797E82"
    />
  </svg>
);
